var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-row',{staticClass:"row-404"},[_c('v-col',{staticClass:"col-404"},[_c('p',[_vm._v("404 | Not found")]),_c('v-btn',{on:{"click":_vm.back}},[_vm._v("Back")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }